var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 16.07C27.96 9.44 22.55 4.1 15.93 4.14 9.3 4.18 3.96 9.59 4 16.21c.04 5.88 4.32 10.86 10.12 11.78v-8.44h-3.05v-3.49h3.05V13.4c0-3.03 1.79-4.7 4.53-4.7.9.01 1.8.09 2.69.24v2.97h-1.51c-.95-.12-1.83.55-1.95 1.5-.02.13-.02.25 0 .38v2.27h3.33l-.53 3.49h-2.8v8.44c5.85-.95 10.14-6 10.13-11.92Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h32v32H0z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.aab86b64b5a974ec40a1d3c62c77c20a.svg";
export { ForwardRef as ReactComponent };